import React, {Component} from 'react';
import PropTypes from 'prop-types';

import GeneralAdmissionBanner from '../../components/react-general-admission-banner';
import QuantitySelectFilterWithState from '../../components/react-quantity-select-filter';

import FilterFooter from './components/react-filter-footer';
import FilterHeader from './components/react-filter-header';
import SlideUpResetButton from './components/react-filter-reset-button';
import SectionSeatMapOptions from './components/react-filter-section-map-options';
import PopularFilters from './components/react-filter-section-popular-filters';
import SectionSeatFeatures from './components/react-filter-section-seat-features';
import SectionSortBy from './components/react-filter-section-sort-by';
import SectionTicketType from './components/react-filter-section-ticket-type';
import PricingFilter from './components/react-pricing-filter';

import './index.scss';

class ListingsFilter extends Component {
  static getFilterOptionList(filterOptions) {
    return Array.isArray(filterOptions) ? filterOptions : [filterOptions];
  }

  renderFilterSections() {
    const {
      showFilterHeader = true,
      showFilterFooter = true,
      showSlideUpResetButton = false,
      seatMapOptions,
      onCloseFilter,
      onResetFilter,
      seatFeatures,
      ticketType,
      sortBy,
      numberOfTickets,
      pricingFilter,
      totalTickets,
      popularFilters,
      isGA,
      hideSeatFeatures,
      isPriceIncludeFeesPreselected,
      showPricingFilter,
    } = this.props;

    return (
      <div className="ListingsFilter">
        {/* Header*/}
        <div className="ListingsFilter__headerWrapper">
          {isGA && <GeneralAdmissionBanner />}
          {isGA && <div className="ListingsFilter__borderBottom" />}
          {showFilterHeader && <FilterHeader onClose={onCloseFilter} onReset={onResetFilter} />}
        </div>

        <span className="ListingsFilter__scrollable_container">
          <div className="ListingsFilter__scrollable_container__padding">
            {/* Number of tickets Section */}
            {numberOfTickets && <QuantitySelectFilterWithState {...numberOfTickets} />}

            {/* Price Filters*/}
            {showPricingFilter ? (
              <section className="ListingsFilter__sectionContainer">
                <PricingFilter {...pricingFilter} />
              </section>
            ) : null}

            {/* Popular Filters Section*/}
            <PopularFilters popularFilters={popularFilters} />

            {/* Sort By Section*/}
            {!isGA && sortBy && <SectionSortBy {...sortBy} />}
            {/* Seat Features Section */}
            {!isGA && seatFeatures && !hideSeatFeatures && <SectionSeatFeatures {...seatFeatures} />}
            {/* Ticket Type Section */}
            {ticketType && <SectionTicketType {...ticketType} />}
            {!isGA && <SectionSeatMapOptions {...seatMapOptions} />}
            {showSlideUpResetButton && (
              <SlideUpResetButton
                onReset={onResetFilter}
                isPriceIncludeFeesPreselected={isPriceIncludeFeesPreselected}
              />
            )}
            {/* End of filter Sections */}
          </div>
        </span>
        {showFilterFooter && <FilterFooter onClick={onCloseFilter} totalTickets={totalTickets} />}
      </div>
    );
  }
  render() {
    return <>{this.renderFilterSections()}</>;
  }
}

ListingsFilter.propTypes = {
  onCloseFilter: PropTypes.func,
  onResetFilter: PropTypes.func.isRequired,
  expandedSections: PropTypes.array,
  className: PropTypes.string,

  /**
   * SeatMap object
   */
  seatMapOptions: PropTypes.object,

  /**
   * Object with seat features available
   */
  seatFeatures: PropTypes.object,

  /**
   * Object with ticket info
   */
  ticketType: PropTypes.object,

  /**
   * Sorting criteria
   */
  sortBy: PropTypes.object,
  numberOfTickets: PropTypes.object,

  /**
   * Pricing filter properties
   */
  pricingFilter: PropTypes.object,

  /**
   * Object with information about number of listings and tickets
   */
  totalTickets: PropTypes.object,

  /**
   * Array of popular filters
   */
  popularFilters: PropTypes.array,

  /**
   * If is general admission
   */
  isGA: PropTypes.bool,

  /**
   * If seat features can be shown
   */
  hideSeatFeatures: PropTypes.bool,

  /**
   * If price include fees by default
   */
  isPriceIncludeFeesPreselected: PropTypes.bool,

  /**
   * If price filter can be shown
   */
  showPricingFilter: PropTypes.bool,

  /**
   * If filter in header is shown
   */
  showFilterHeader: PropTypes.bool,

  /**
   * If filter in footer is shown
   */
  showFilterFooter: PropTypes.bool,

  /**
   * If reset button is available
   */
  showSlideUpResetButton: PropTypes.bool,
};

export default ListingsFilter;
